import Dashboard from 'newViews/Dashboard';
import Charts from 'newViews/Charts';
import Profile from 'newViews/Profile';
import PatientInfo from "./newViews/PatientProfile/PatientInfo";
import NewExercise from "./newViews/PatientProfile/Exercises/NewExersice";
import EditExersice from "./newViews/PatientProfile/Exercises/EditExersice";
import SessionReport from "./newViews/PatientProfile/Exercises/SessionReport";
import AddNewPatient from "./newViews/AddNewPatient";
import PatientProfile from "./newViews/PatientProfile/PatientProfile";
import HomePage from "./newViews/HomePage";

/**
 * TODO: fix video player in new exercise page
 * TODO: build add patient in home page
 * TODO: make the side bar responsive
 * TODO: make the other views of website
 * TODO: add the apis to the site
 * TODO: delete temp for test route
 */

var routes = [
  {
    path: "/dashboard",
    //name: "Dashboard",
    name: "داشبورد",
    rtlName: "داشبورد",
    icon: "tim-icons icon-components",
    component: <HomePage />,
    layout: "/rtl",
  },
  {
    path: "/inbox",
    //name: "Dashboard",
    name: "صندوق ورودی",
    rtlName: "صندوق ورودی",
    icon: "tim-icons icon-email-85",
    component: <HomePage />,
    layout: "/rtl",
  },
  {
    path: "/chat",
    //name: "Dashboard",
    name: "گفتگوی آنلاین",
    rtlName: "گفتگوی آنلاین",
    icon: "tim-icons icon-chat-33",
    component: <HomePage />,
    layout: "/rtl",
  },
  {
    path: "/profile",
    //name: "Dashboard",
    name: "پروفایل",
    rtlName: "پروفایل",
    icon: "tim-icons icon-single-02",
    component: <Profile />,
    layout: "/rtl",
  },
  {
    path: "/chart",
    //name: "Dashboard",
    name: "اطلاعات آماری",
    rtlName: "اطلاعات آماری",
    icon: "tim-icons icon-chart-bar-32",
    component: <HomePage />,
    layout: "/rtl",
  },
  {
    path: "/support",
    //name: "Dashboard",
    name: "تماس با پشتیبانی",
    rtlName: "تماس با پشتیبانی",
    icon: "tim-icons icon-settings-gear-63",
    component: <HomePage />,
    layout: "/rtl",
  },
  {
    path: "/newexercise",
    //name: "Dashboard",
    name: "افزودن جلسه",
    rtlName: "افزودن جلسه",
    icon: "tim-icons icon-settings-gear-63",
    component: <NewExercise/>,
    layout: "/rtl",
  },
  {
    path: "/editexercise",
    //name: "Dashboard",
    name: "افزودن جلسه",
    rtlName: "افزودن جلسه",
    icon: "tim-icons icon-settings-gear-63",
    component: <EditExersice/>,
    layout: "/rtl",
  },
  {
    path: "/addpatient",
    //name: "Dashboard",
    name: "افزودن بیمار جدید",
    rtlName: "افزودن بیمار جدید",
    icon: "tim-icons icon-components",
    component: <AddNewPatient />,
    layout: "/rtl",
  },
  {
    path: "/patientprofile",
    //name: "Dashboard",
    name: "پروفایل بیمار",
    rtlName: "پروفایل بیمار",
    icon: "tim-icons icon-components",
    component: <PatientProfile />,
    layout: "/rtl",
  },
  {
    path: "/sessionreport",
    //name: "Dashboard",
    name: "گزارش جلسه",
    rtlName: "گزارش جلسه",
    icon: "tim-icons icon-components",
    component: <SessionReport />,
    layout: "/rtl",
  },
];
export default routes;
